import CarriersData from "@/GeneratedFixtures/CarriersData.json";
import _ from "lodash";
import { displayNameForCarrier } from "@/Data/displayNameForCarrier";

// CarriersData has a row per carrier *service*, so the identifiers repeat.
export function getCarriers() {
  const carrierIdentifiers = CarriersData.map((c) => c.carrierIdentifier);
  const uniqueCarrierIdentifiers = _.uniq(carrierIdentifiers);
  return uniqueCarrierIdentifiers.map((ci) => ({
    identifier: ci,
    displayName: displayNameForCarrier(ci),
  }));
}
